import React from "react";
import { Div, Image, Text } from "atomize";
import { useLocomotiveScroll } from 'react-locomotive-scroll';

export default function KeyFeatures() {
  const { scroll } = useLocomotiveScroll();

  scroll?.on("scroll", (instance) => {
    if (Object.keys(instance.currentElements).includes('el8')) {
      const element = instance.currentElements.el8;
      element.el.style.transform = `rotate(${-50 + (((instance.scroll.y - element.top + window.innerHeight) / window.innerHeight) * 10)}deg)`;
    }
  });

  return (
    <Div tag="section" data-scroll-section pos="relative" overflow="visible" p={{ t: { xs: "7.5rem" } }}>
      <Div data-scroll data-scroll-speed="-0.5" pos="absolute" top={{ xs: "0%", sm: '-24%', md: '0', xl: '0%' }} overflow="visible" left="0" right="0" w="100%">
        <Image d={{ xs: 'none', md: 'block' }} src="/images/grain/grain-bg-desktop.jpg" alt="grain-bg-desktop" />
        <Image d={{ xs: 'block', md: 'none' }} src="/images/grain/grain-bg-mobile.jpg" alt="grain-bg-mobile" />
        <Div className="noise img" />
      </Div>
      <Div pos="relative" zIndex="1" overflow="visible">
        <Div data-scroll data-scroll-speed="1" data-scroll-offset="-100%,0%" overflow="visible" pos={{ md: "absolute" }} left={{ md: "2.5rem" }} top={{ md: "80px", lg: "96px", xl: "140px" }}>
          <Div
            tag="h2"
            data-scroll
            bg="black"
            border="1px solid"
            borderColor="outline"
            textSize={{ xs: "paragraph", lg: "subtitle", xl: "subheader" }}
            h={{ xs: "104px", lg: "140px", xl: "168px" }}
            w={{ xs: "280px", lg: "340px", xl: "440px" }}
            d="flex"
            align="center"
            justify="center"
            rounded="50%"
            textWeight="300"
            transform={{ xs: "rotate(-10deg)", md: "rotate(-50deg)" }}
            textTransform="uppercase"
            m={{ xs: "0 1.5rem 2.5rem", sm: "0 3.5rem 2.5rem", md: '0' }}
          >
            Key features ☻
          </Div>
        </Div>
        {features.map((feature, index) => {
          return (
            <Div
              d="flex"
              key={`feature-${index}`}
              border={{ b: "1px solid", t: index === 0 ? "1px solid" : "0" }}
              borderColor="light"
              p={{ xs: "1rem 1.25rem", sm: "1rem 3.5rem", lg: "1.25rem 0" }}
              align="center"
            >
              <Div d={{ xs: 'none', md: 'block' }} flexGrow="1" />
              <Div
                flexGrow={{ md: "1.5", xl: "1.9" }}
                d="flex"
                align="center"
                p={{ l: { xs: "0", lg: "1rem" } }}
              >
                <Image
                  src={feature.icon}
                  h={{ xs: "56px", lg: "72px", xl: "104px" }}
                  w="auto"
                  m={{ r: { xs: "2rem", lg: "2.5rem" } }}
                  alt={feature.altText}
                />
                <Text textWeight="300" textSize={{ xs: "description", lg: "subtitle", xl: "header" }}>
                  {feature.text}
                </Text>
              </Div>
            </Div>
          );
        })}
      </Div>
    </Div>
  );
}

const features = [{
  text: "High resolution 3D shapes.",
  icon: "images/features-icons/feature1.png",
  altText: "High resolution 3D shapes icon",
}, {
  text: "Customizable tones and fills.",
  icon: "images/features-icons/feature2.png",
  altText: "Customizable tones and fills icon",
}, {
  text: "Example screens and textures.",
  icon: "images/features-icons/feature3.png",
  altText: "Example screens and textures icon",
}, {
  text: "Editable Source files.",
  icon: "images/features-icons/feature4.png",
  altText: "Editable Source files icon",
}];